import React, { Component } from 'react';
import { Button, Modal, Table } from 'antd';
import styles from './style.module.scss';
import { QUERY } from '../../utilities/network';
import { observer } from 'mobx-react';
import { observable, toJS, runInAction } from 'mobx';
import dayjs from 'dayjs';
import { RouteComponentProps } from 'react-router';
import CreateGroupFormModal from '../../components/createGroupFormModal';

@observer
export default class GroupList extends Component<RouteComponentProps<{}>> {
	@observable loading = false;
	@observable groups: Array<GroupType> = [];
	@observable showModal = false;
	columns: Array<any> = [
		{
			title: 'No.',
			dataIndex: 'key',
			key: 'key',
			width: 50
		},
		{
			title: 'Group name',
			dataIndex: 'name',
			key: 'name',
			width: 100
		},
		{
			title: 'Total members',
			dataIndex: 'total_number',
			key: 'total_number',
			width: 100,
			align: 'center'
		},
		{
			title: 'Activated members',
			dataIndex: 'activated_number',
			key: 'activated_number',
			width: 100,
			align: 'center'
		},
		{
			title: 'Country',
			dataIndex: 'country',
			key: 'country',
			width: 100,
			align: 'center'
		},
		{
			title: 'Created date',
			dataIndex: 'created_at',
			key: 'created_at',
			width: 100,
			align: 'center'
		},
		{
			title: 'Action',
			key: 'action',
			render: (text: any, record: GroupType) => (
				<Button onClick={() => this._goToGroupDetail(record)}>View group</Button>
			),
			width: 100,
			align: 'center'
		}
	];

	async componentDidMount() {
		await this._fetchGroupList();
	}

	render() {
		return (
			<div>
				<article>Groups</article>
				<div className={styles.container}>
					<Button
						type="primary"
						icon="plus"
						className={styles.add_btn}
						onClick={this._showCreatingNewGroup}
					>
						GROUP
					</Button>
					<Table
						className={styles.table}
						dataSource={toJS(this.groups)}
						columns={this.columns}
						pagination={{ pageSize: 25, style: { marginRight: 16 } }}
						loading={this.loading}
					/>
				</div>

				{this._renderCreatingGroupModal()}
			</div>
		);
	}

	_renderCreatingGroupModal = () => {
		return (
			<CreateGroupFormModal
				visible={this.showModal}
				hideModal={this._hideCreatingNewGroup}
				onCreateGroupSuccess={this._fetchGroupList}
			/>
		);
	};

	_fetchGroupList = async () => {
		try {
			this.loading = true;
			const res = await QUERY<{ groups: Array<GroupType> }>(GET_GROUPS);
			res.groups.forEach((group, index) => {
				group.key = index + 1;
				group.created_at = dayjs(group.created_at).format('DD.MM.YYYY');
			});

			runInAction(() => {
				this.groups = res.groups;
				this.loading = false;
			});
		} catch (e) {
			Modal.error({
				title: 'Oops, something goes wrong.',
				content: e.message,
				okText: 'GOT IT'
			});
		}
	};

	_showCreatingNewGroup = () => {
		this.showModal = true;
	};

	_hideCreatingNewGroup = () => {
		this.showModal = false;
	};

	_goToGroupDetail = (record: GroupType) => {
		this.props.history.push(`/admin/group-detail?id=${record.group_id}&name=${record.name}`);
	};
}

export const GET_GROUPS = `
query {
  groups {
    group_id
    name
    description
    country
    created_at
    total_number
    activated_number
  }
}`;

export interface GroupType {
	key: number;
	group_id: number;
	name: string;
	description: string;
	country: string;
	created_at: string;
	total_number: number;
	activated_number: number;
}
